import React, { useEffect, useState, useContext } from 'react';

import Transactions from './Transactions';
import Participated from './Participated';
import BusinessRank from './BusinessRank';
import RankBaseQuestion from './RankBaseQuestion';
import Services from './Services';
import Users from './Users';
import Sales from './Sales';
import UsesServices from './UsesServices';
import Changes from './Changes';
import RankBusinessQuestion from './RankBusinessQuestion';
import RankOpinionQuestion from './RankOpinionQuestion';
import RankOpinionBusiness from './RankOpinionBusiness';
import { Context } from '../../context/UserContext';
import OpinionSMS from './OpinionSMS';
import DataHistory from './DataHistory';

const ReportHistory = () => {

    const context = useContext(Context);
    const [currentTab, setCurrentTab] = useState('dataHistory');

    return (
        <div className="card">
            <div className="card-header"><div className="card-title" >گزارشات تاریخچه </div></div>
            <div className="card-body">
                <div className="row mb-5">
                    <div className="col-md-1 d-grid">
                         <button onClick={e => setCurrentTab('dataHistory')} className={currentTab == 'dataHistory' ? 'btn btn-info' : 'btn btn-info-light'}>تاریخچه</button>

                    </div>
             
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-0">
                            <div className="card-body report-card" style={{ background: '#f0f0f0', borderRadius: 7 }}>
                                 {currentTab == 'dataHistory' ? <DataHistory /> : ''}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReportHistory;